// src/components/HospitalAllMenuDashboard.jsx
import React, { useState } from "react";
import { Typography, useTheme, useMediaQuery } from "@mui/material";

import WardDashBoard from "./WardBedManagement/WardDashBoard";
import DoctorDashBoard from "./DoctorManagement/DoctorDashBoard";
import PatientDashBoard from "./Patient Management/PatientDashBoard";
import OpdDashBoard from "./OPD/OpdDashBoard";
import IpdDashBoard from "./IPD/IpdDashBoard";
import StaffDashBoard from "./Staff Management/StaffDashBoard";
import AccountDashBoard from "./AccountandBilling/AccountDashBoard";
import PharmacyMedicalStoreDashBoard from "./PharmacyMedicalStore/PharmacyMedicalStoreDashBoard";
import RadiologyDashBoard from "./Radiology/RadiologyDashBoard";
import MedicineInventoryDashBoard from "./MedicineInventory/MedicineInventoryDashBoard";
import ReportsAndAnalycisDashBoard from "./ReportsandAnalytics/ReportsAndAnalycisDashBoard";
import HospitalAdminDashBoard from "./HospitalAdmin/HospitalAdminDashBoard";
import HospitolSecurityAuditDashBoard from "./HospitalSecurityAudit/HospitolSecurityAuditDashBoard";

import { decrypt } from "../components/cryptoUtil";
import DashboardCards from "./HospitalDashBoardCards";
import { includeCardForRoles, ROLES } from "./componenet/heading";


const HospitalAllMenuDashboard = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  let decryptedData = {};
  try {
    const tokenData = localStorage.getItem("tokenData");
    decryptedData = tokenData ? JSON.parse(decrypt(tokenData)) : {};
  } catch (e) {
    console.warn("Failed to decrypt tokenData", e);
  }

  const userName = decryptedData.userfullname || "";
  const userRole = decryptedData.userrole || "";
  const [activeIndex, setActiveIndex] = useState(true);
  //console.log("User Role:", userRole); // Debugging line to check userRole value


const cardRoles = {
  "Patient Management": [ROLES.RECEPTIONIST], // only userRole 101 can see
  "OPD Management": [ROLES.RECEPTIONIST],   // only userRole 102 can see
  "IPD Management": [ROLES.RECEPTIONIST],
  "Ward & Bed Management": [ROLES.STAFF],
  "Doctor Management": [ROLES.ACCOUNTSECTION],
  "Staff Management": [ROLES.DOCTOR,ROLES.RECEPTIONIST],
   "Pharmacy Management": [ROLES.RECEPTIONIST], // only userRole 101 can see
  "Medical Inventory Management": [ROLES.RECEPTIONIST],   // only userRole 102 can see
  "Radiology & Lab Management": [ROLES.RECEPTIONIST],
  "Account & Billing Management": [ROLES.STAFF],
  "Reporting & Analytics": [ROLES.ACCOUNTSECTION],
  "Administration & Settings": [ROLES.DOCTOR,ROLES.RECEPTIONIST],
  "System Configuration": [ROLES.DOCTOR,ROLES.RECEPTIONIST],
};



  const cards = [
    ...includeCardForRoles(cardRoles["Patient Management"], userRole,{title: "Patient Management",
       icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🗣</span> : null,
       component: <PatientDashBoard />, category: "Clinical Services" }),
    ...includeCardForRoles(cardRoles["OPD Management"], userRole,{ title: "OPD Management", 
       icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🏨</span> : null,
      component: <OpdDashBoard />, category: "Clinical Services" }),
    ...includeCardForRoles(cardRoles["IPD Management"], userRole,{ title: "IPD Management", 
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🏪</span> : null,
       component: <IpdDashBoard />, category: "Clinical Services" }),
    ...includeCardForRoles(cardRoles["Ward & Bed Management"], userRole,{ title: "Ward & Bed Management",
   
         icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🛌</span> : null,
       component: <WardDashBoard />, category: "Clinical Services" }),
    
    
      //  ...includeCardForRoles(cardRoles["Doctor Management"], userRole,{ title: "Doctor Management", 
      // icon: !isMobile ? <span style={{ fontSize: "2rem" }}>👨‍⚕️</span> : null,
      //  component: <DoctorDashBoard />, category: "Doctor & Staff Management" }),


      



    ...includeCardForRoles(cardRoles["Pharmacy Management"], userRole,{ title: "Pharmacy Management", 
icon: !isMobile ? <span style={{ fontSize: "2rem" }}>💊</span> : null,
      component: <PharmacyMedicalStoreDashBoard />, category: "Pharmacy & Medical Store" }),
   ...includeCardForRoles(cardRoles["Medical Inventory Management"], userRole,{ title: "Medical Inventory Management", 
    icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📉</span> : null,
     component: <MedicineInventoryDashBoard />, category: "Pharmacy & Medical Store" }),
    ...includeCardForRoles(cardRoles["Radiology & Lab Management"], userRole,{ title: "Radiology & Lab Management", 
icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🕵️‍♂️</span> : null,
      component: <RadiologyDashBoard />, category: "Radiology & Lab Services" }),




       ...includeCardForRoles(cardRoles["Staff Management"], userRole,{ title: "Staff Management", 
    icon: !isMobile ? <span style={{ fontSize: "2rem" }}>👨‍⚕️👩🏽‍🍳</span> : null,
    component: <StaffDashBoard />, category: "Administration & Finance" }),

    
    ...includeCardForRoles(cardRoles["Account & Billing Management"], userRole,{ title: "Account & Billing Management", 
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <AccountDashBoard />, category: "Administration & Finance" }),
    ...includeCardForRoles(cardRoles["Reporting & Analytics"], userRole,{ title: "Reporting & Analytics", 
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🖨️</span> : null,
       component: <ReportsAndAnalycisDashBoard />, category: "Administration & Finance" }),
    ...includeCardForRoles(cardRoles["Administration & Settings"], userRole,{ title: "Administration & Settings", 
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🎖</span> : null,
      component: <HospitalAdminDashBoard />, category: "Administration & Finance" }),
    ...includeCardForRoles(cardRoles["System Configuration"], userRole,{ title: "System Configuration", 
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🛠</span> : null,
      component: <HospitolSecurityAuditDashBoard />, category: "Administration & Finance" }),
  ];

  return (
    <>
      <DashboardCards
        cards={cards}
        welcomeMessage={
          <Typography variant="h5" align="center" gutterBottom>
            👨‍⚕️ Welcome {userName}
          </Typography>
        }
        menulabel={0} // 0 = master page
        onActiveChange={(isRoot) => setActiveIndex(isRoot)}
      />

      {/* Top-level only UI */}
      {/* {activeIndex && (
        <Typography variant="h6" align="center" sx={{ mt: 2 }}>
          Administration & Finance
        </Typography>
      )} */}
    </>
  );
};

export default HospitalAllMenuDashboard;
